export enum ITEM_MODIFY {
    "not_modified" = 1,
    "modified"
}

export interface ItemResponse {
    "code": string;
    "keyId": string;
    "modify": ITEM_MODIFY.modified | ITEM_MODIFY.not_modified;
    /**
     * @caution
     * Unlike other objects, this ObjectId field is stored as "id" instead of "_id" in the database.
     */
    "id"?: string;
    nItem?: number;

    /**
     * The amount representating the not devolutioned items into a original invoice
     * 
     * Into itens of a NFe-F, this value can be -1, if the item was devolutioned completely
     */
    "amount": number,
    /** last cost of part when the invoice was created */
    "lastCost"?: number;
    /** average cost of part when the invoice was created */
    "averageCost"?: number;
    "invoiceMkgo"?: string;

    unitValue?: number;
    totalAvailableAmount?: number;
    isForItemManagement?: boolean;

    totalFreightValue?: number;
    remainingFreightValue?: number;
    totalOtherExpensesValue?: number;
    remainingOtherExpensesValue?: number;
    totalDiscountValue?: number;
    remainingDiscountValue?: number;
    totalInsuranceValue?: number;
    remainingInsuranceValue?: number;
}
